import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Layout from "../../Layout";
import Button from "@material-ui/core/Button";
import PersonAdd from "@material-ui/icons/PersonAdd";
import PersonIcon from "@material-ui/icons/Person";
import { Link } from "react-router-dom";
import useAuth from "Hooks/useAuth";
import googleAnalytics from "fuction/googleAnalytics";

const useStyles = makeStyles(() => ({
  menueText: {
    fontSize: "16px",
  },
}));

export default function Setting(props) {
  const { state } = useAuth();
  const classes = useStyles();

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Media - 設定";
  }, []);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, state.user.account_id);
  }, [props.location.pathname]);

  return (
    <Layout
      content={
        <Grid className={classes.menueText}>
          {state.user.admin && (
            <>
              <Grid item>
                <Link to="/media/config/user">
                  <Button  className={classes.menueText} startIcon={<PersonAdd />} href="/media/config/user">
                    ユーザアカウント管理
                  </Button>
                </Link>
              </Grid>
            </>
          )}
          <Grid item>
            <Link to="/media/config/password">
              <Button  className={classes.menueText} startIcon={<PersonIcon />} href="/media/config/password">
                パスワード変更
              </Button>
            </Link>
          </Grid>
        </Grid>
      }
    />
  );
}
